module.exports = __webpack_public_path__ + "8afcfffd8791647d8ad5c71012f3b35c.svg";